import { FormEvent } from "react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/router";
import { LoadingButton } from "@/components/ui/loading-button";
import { getApiErrorCode, getApiErrorMessage } from "@/store/api";
import { useCreateSessionMutation } from "@/store/entry-api";
import styles from "./seo-page.module.css";

export function SeoCta() {
  const router = useRouter();
  const [createSession, createState] = useCreateSessionMutation();

  const startBrainstorm = async (event: FormEvent) => {
    event.preventDefault();
    createState.reset();

    try {
      const result = await createSession().unwrap();
      await router.push(`/session/${result.session.id}`);
    } catch (cause) {
      if (getApiErrorCode(cause) === "OWNED_SESSION_LIMIT") {
        await router.push("/dashboard?upgrade=monthly");
      }
    }
  };

  return (
    <section className={styles.cta} aria-labelledby="seo-cta-heading">
      <div>
        <p className={styles.eyebrow}>PUT IT INTO PRACTICE</p>
        <h2 id="seo-cta-heading">Turn everyone’s thinking into one clear next step.</h2>
        <p>
          See how teams use Boardblend, or open a shared canvas and start now.
        </p>
      </div>
      <div className={styles.ctaActions}>
        <Link className={styles.primaryCta} href="/#examples">
          See Boardblend examples <ArrowRight aria-hidden="true" />
        </Link>
        <form onSubmit={startBrainstorm}>
          <LoadingButton
            type="submit"
            variant="outline"
            loading={createState.isLoading}
          >
            Start a brainstorm
          </LoadingButton>
        </form>
      </div>
      {createState.error &&
        getApiErrorCode(createState.error) !== "OWNED_SESSION_LIMIT" && (
          <p className={styles.ctaError} role="alert">
            {getApiErrorMessage(createState.error, "Something went wrong")}
          </p>
        )}
    </section>
  );
}
